// extracted by mini-css-extract-plugin
export default {"menu-tab":"bottom-tab_menu-tab__i5nHQ","active":"bottom-tab_active__Edq-I"};